import React, { lazy } from 'react';
export function ProductIntro() {
  return <section className="py-8 md:py-14 bg-white" data-id="element-228">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-229">
        <p className="text-gold font-semibold text-sm uppercase tracking-widest mb-3 md:mb-4" data-id="element-230">
          INTRODUCING…
        </p>

        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-dark mb-3 md:mb-4" data-id="element-231">
          The Home Healing Handbook
        </h2>

        <p className="text-xl md:text-2xl text-muted mb-4 md:mb-6 max-w-2xl mx-auto" data-id="element-232">
          300 Ancient & Plant-Based Remedies Organized by Symptom — So You
          Always Know Exactly What To Do
        </p>

        {/* Product Image */}
        <div className="relative max-w-md mx-auto mb-4 md:mb-6" data-id="element-233">
          <img src="https://cdn.magicpatterns.com/uploads/bUHpjjc8PxcS7BkwPACEKN/portada_book_herbal_(1).jpg" alt="The Home Healing Handbook — 300 Natural Remedies Organized by Symptom" className="aspect-square object-cover rounded-2xl shadow-xl border border-gold-light/50" loading="lazy" data-id="element-234" />
        </div>

        {/* Feature Pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-4 md:mb-6" data-id="element-235">
          <span className="bg-primary/10 text-primary font-medium px-4 py-2 rounded-full text-sm" data-id="element-236">
            300+ Natural Remedies
          </span>
          <span className="bg-primary/10 text-primary font-medium px-4 py-2 rounded-full text-sm" data-id="element-237">
            Full Family Coverage
          </span>
          <span className="bg-primary/10 text-primary font-medium px-4 py-2 rounded-full text-sm" data-id="element-238">
            500+ Pages of Guidance
          </span>
        </div>

        <p className="text-lg text-dark max-w-2xl mx-auto leading-relaxed" data-id="element-239">
          The first and only natural remedy guide organized the way your brain
          actually works in a health emergency —{' '}
          <strong data-id="element-240">by symptom, not by herb.</strong>
        </p>

        <p className="text-lg text-muted mt-3 md:mt-4 max-w-2xl mx-auto" data-id="element-241">
          No more searching.{' '}
          <span className="underline decoration-gold decoration-2 underline-offset-4 font-semibold text-dark" data-id="element-242">
            No more confusion.
          </span>{' '}
          No more feeling helpless. You open it, find your symptom, and{' '}
          <span className="underline decoration-primary decoration-2 underline-offset-4 font-semibold text-dark" data-id="element-243">
            you know exactly what to do.
          </span>
        </p>

        {/* Scroll invite arrow */}
        <div className="flex justify-center mt-5 md:mt-8 mb-2 animate-bounce" data-id="element-244">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gold/60" data-id="element-245">
            <path d="M12 5v14" data-id="element-246" />
            <path d="m19 12-7 7-7-7" data-id="element-247" />
          </svg>
        </div>
      </div>
    </section>;
}